import styles from './ViewPage.module.scss';

const ViewPage = (props) => {
	const { viewPage } = props;

	return <div className={`${styles.root} page`}>{viewPage}</div>;
};

export default ViewPage;
